import { Link } from "react-router-dom";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";

const TourCard = ({ tour }) => {
  if (!tour) return null;

  const { id, title, image } = tour;

  return (
    <Link
      to={`/tours/${id}`}
      className="
        group relative block h-full aspect-[3/4] min-h-[430px] overflow-hidden
        rounded-[2rem] bg-gray-100 shadow-xl shadow-black/5
        transition-all duration-700 hover:-translate-y-2 hover:shadow-2xl
      "
      aria-label={title ?? "Tour package"}
    >
      <div className="absolute inset-0">
        {image && (
          <img
            src={image}
            alt={title}
            className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-110"
          />
        )}

        <div className="absolute inset-0 bg-gradient-to-t from-black/88 via-black/25 to-transparent" />
        <div className="absolute inset-0 bg-black/10 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
      </div>

      <div className="absolute inset-0 flex flex-col justify-end p-5">
        <div className="flex items-end justify-between gap-4 pb-1">
          <div className="min-w-0 max-w-[calc(100%-4.5rem)]">
            <h3 className="truncate text-base leading-none tracking-tight text-white drop-shadow-[0_2px_12px_rgba(0,0,0,0.55)]">
              {title ?? "Tour Package"}
            </h3>
          </div>

          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-orange-main text-gray-900 shadow-xl shadow-orange-main/30 opacity-0 translate-y-3 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 group-hover:bg-orange-light">
            <FaArrowUpRightFromSquare className="text-base" />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default TourCard;
